import { ApiBase } from "./api-base";

export class HttpAdminApi extends ApiBase {
  onApiName(): string {
    return "AdminApi";
  }

  onUrlPath(): string {
    return "/admin";
  }

  public async post(param: any) {
    const response = await this.requestPost(param);
    return response;
  }
}
